import React, { useEffect, useState } from 'react'

import { get } from '@js/common/api'
import { getUrl } from '@js/common/getUrlByDomain'
import User from '@js/common/user'

import Modal from '@f/components/Modal'
import CTA from '@f/elements/CTA'
import Icon from '@f/elements/Icon'
import CardCarousel from '@f/widgets/CardCarousel'

import RequestWizard from '@f-fertighaus/applications/RequestWizard'

import OfficeDetailCard from './OfficeDetailCard'

const OfficeDetail = ({ officeDetails, setSelectedOffice }) => {
  const constructionMethod = [
    {
      id: '1',
      name: 'Ausbauhaus'
    },
    {
      id: '2',
      name: 'Bausatzhaus'
    },
    {
      id: '3',
      name: 'Schlüsselfertig'
    }
  ]

  const [localPartner, setLocalPartner] = useState(null)
  const [vendorHouses, setVendorHouses] = useState([])

  useEffect(() => {
    const { postcode } = User.getLocation()
    if (postcode) {
      get(
        `sales-offices/?vendor_nid=${officeDetails.office.vendor_nid}&nid=${officeDetails.office.nid}`
      ).then(data => {
        setLocalPartner(
          data[0]?.faces.find(
            agent =>
              agent.active && agent.display_delivery_regions.includes(postcode)
          )
        )
      })
    }

    if (officeDetails.vendor) {
      get('houses', {
        vendor_nid__in: officeDetails.office.vendor_nid,
        limit: 4
      }).then(data => {
        setVendorHouses(data.results)
      })
    }
  }, [])

  const openRequest = async () => {
    const modal = new Modal()

    modal.openModal({
      component: (
        <RequestWizard
          requestType='vendor-detail-form'
          vendors={[officeDetails.vendor?.nid]}
        />
      )
    })
  }

  let officeSlug = null
  if (
    officeDetails.vendor &&
    officeDetails.office.nid !== officeDetails.vendor.nid &&
    officeDetails.office.vendor_slug
  ) {
    officeSlug = `${getUrl('vendorDetail')(officeDetails.office.vendor_slug)}/`
  } else if (officeDetails.vendor && officeDetails.office.office_slug) {
    officeSlug = getUrl('vendorOffice')(
      officeDetails.vendor.slug,
      officeDetails.office.office_slug
    )
  }

  if (officeSlug) {
    officeSlug = officeSlug.replace('//', '/')
  }

  if (officeSlug === officeDetails.vendor?.url) {
    officeSlug = null
  }

  return (
    <>
      <div className='[ f-hidden:s f-p-h-020 f-p-t-020 ]'>
        <CTA
          type='text-primary'
          tag='button'
          className='[ f-t-body ]'
          onClick={() => setSelectedOffice(null)}>
          <Icon
            icon='left-link-16px'
            className='[ f-icon-020 f-icon-t-body f-c-st-inherit f-m-r-010 ]'
          />
          Zurück zur Übersicht
        </CTA>
      </div>
      <div className='[ f-p-b-020 ]'>
        <div className='[ f-p-h-020 ]'>
          <div className='[ f-pos-rel f-radius-card-large f-shadow-strong f-m-t-020 f-p-a-0 ] OfficeMap-list-item'>
            <OfficeDetailCard type='detail' item={officeDetails.office} />
          </div>
        </div>
        <div className='[ f-p-h-020 ]'>
          <span className='[ f-d-bl f-t-tminor f-p-t-030 ]'>
            Anbieterprofil
          </span>
          <dl>
            <div className='[ f-d-flr f-fl-wrap f-m-t-010 ]'>
              <dt className='[ f-p-r-020 ] OfficeMap-list-item-description'>
                Ausbaustufen
              </dt>
              <dd>
                {officeDetails.office.construction_methods
                  .map(
                    id =>
                      constructionMethod.find(method => method.id === id).name
                  )
                  .join(', ')}
              </dd>
            </div>
            {officeDetails.vendor &&
            officeDetails.vendor.number_of_houses &&
            parseInt(officeDetails.vendor.number_of_houses) > 0 ? (
              <div className='[ f-d-flr f-fl-wrap f-m-t-010 ]'>
                <dt className='[ f-p-r-020 ] OfficeMap-list-item-description'>
                  Hauskatalog
                </dt>
                <dd>
                  <CTA
                    type='text-primary'
                    tag='a'
                    className='[ f-c-fo-ter ]'
                    href={`${getUrl(
                      'houseList'
                    )()}?vendor_nid__in=${officeDetails.vendor.nid
                      .split('.')
                      .pop()}`}>
                    {officeDetails.vendor.number_of_houses} Häuser
                  </CTA>
                </dd>
              </div>
            ) : null}
            {officeDetails.vendor && officeDetails.vendor.year_of_foundation ? (
              <div className='[ f-d-flr f-fl-wrap f-m-t-010 ]'>
                <dt className='[ f-p-r-020 ] OfficeMap-list-item-description'>
                  Gründungsjahr
                </dt>
                <dd>{officeDetails.vendor.year_of_foundation}</dd>
              </div>
            ) : null}
            {officeDetails.vendor &&
            officeDetails.vendor.number_of_employees ? (
              <div className='[ f-d-flr f-fl-wrap f-m-t-010 ]'>
                <dt className='[ f-p-r-020 ] OfficeMap-list-item-description'>
                  Mitarbeiter
                </dt>
                <dd>{officeDetails.vendor.number_of_employees}</dd>
              </div>
            ) : null}
            <div className='[ f-d-flr f-fl-wrap f-m-t-020 ]'>
              {officeDetails.vendor ? (
                <span className='[ f-p-r-020 ] OfficeMap-list-item-description'>
                  <CTA
                    type='text-primary'
                    tag='a'
                    href={officeDetails.vendor.url}>
                    Zum Anbieterprofil
                  </CTA>
                </span>
              ) : null}
              {officeSlug ? (
                <span>
                  <CTA type='text-primary' tag='a' href={officeSlug}>
                    Zum Beratungsbüro
                  </CTA>
                </span>
              ) : null}
            </div>
          </dl>
          {officeDetails.vendor ? (
            <CTA
              type='block-primary'
              tag='button'
              className='[ f-m-t-040 ]'
              onClick={openRequest}
              wtData={{
                'CTA-click': {
                  location: 'vendor-map-office-detail',
                  label: 'vendor-wizard-item',
                  indicates: ['funnel-entry']
                }
              }}>
              Kostenlose Infos anfordern
            </CTA>
          ) : null}
        </div>

        {officeDetails.vendor &&
        officeDetails.vendor.seals_of_quality?.length > 0 ? (
          <div className='[ f-p-h-020 ]'>
            <span className='[ f-d-bl f-t-tminor f-p-t-040 ]'>
              Auszeichnungen, Zertifikate &amp; Mitgliedschaften
            </span>
            {officeDetails.vendor.seals_of_quality.map(seal => (
              <img
                src={seal['max-100x100']}
                className='[ f-m-t-020 f-m-r-020 ] OfficeMap-list-item-seal'
              />
            ))}
          </div>
        ) : null}
        {localPartner ? (
          <div className='[ f-p-h-020 ]'>
            <span className='[ f-d-bl f-t-tminor f-p-t-040 ]'>
              Ihr lokaler Baupartner
            </span>
            <div className='[ f-pos-rel f-c-bo-pri f-shadow f-c-ba-whi f-p-a-020 f-p-t-030 f-m-v-010 f-t-centre ] OfficeMap-list-local-agent'>
              {localPartner.avatar ? (
                <img
                  src={localPartner.avatar}
                  className='VendorOfficesPage-avatar'
                  width='64'
                  height='64'
                />
              ) : (
                <Icon
                  icon='author-64px-fill'
                  className='[ f-icon-080 f-c-fi-pri ]'
                />
              )}

              <div className='[ f-t-body f-m-t-010 ]'>
                {localPartner.first_name} {localPartner.last_name}
              </div>
            </div>
          </div>
        ) : null}
        {vendorHouses.length > 0 ? (
          <div className='[ f-overflow ]'>
            <div className='[ f-p-h-020 ]'>
              <span className='[ f-d-bl f-t-tminor f-p-t-040 f-p-b-020 ]'>
                Empfohlene Häuser von {officeDetails.vendor.display_name}
              </span>
              <CardCarousel
                items={vendorHouses}
                item_nid_type='house_nid'
                card='house-small'
              />
            </div>
          </div>
        ) : null}
      </div>
      <div className='[ f-hidden:s f-p-a-020 ]'>
        <CTA
          type='text-primary'
          tag='button'
          className='[ f-t-body ]'
          onClick={() => setSelectedOffice(null)}>
          <Icon
            icon='left-link-16px'
            className='[ f-icon-020 f-icon-t-body f-c-st-inherit f-m-r-010 ]'
          />
          Zurück zur Übersicht
        </CTA>
      </div>
    </>
  )
}

export default OfficeDetail
